import { Button, Drawer, Grid, Form } from "antd";
import CreateSupplierForm from "./CreateSupplierForm";
import "./supplier.css"

const SupplierDrawer = ({ open, onClose, authInfo, onCreated }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [form] = Form.useForm(); // ✅ shared form instance

  return (
    <Drawer
      open={open}
      width={screens.md ? 720 : "100%"}
      title="Create Supplier"
      onClose={onClose}
      destroyOnHidden={true}
      styles={{
        body: { paddingInline: screens.md ? 40 : 20 , paddingBottom: 88},
        wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }    
      }}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
          }}
        >
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      }
    >
      <CreateSupplierForm
        form={form}          // ✅ pass form down
        authInfo={authInfo}
        isDrawer
        onSuccess={(createdSupplier) => {
          onCreated(createdSupplier);
          onClose();
        }}
      />
    </Drawer>
  );
};

export default SupplierDrawer;
